import React from "react";
import { useObserver } from "mobx-react";
import locale from "@bonliva-crm/locale";
import { store } from "@store";
import Select from "@common/Select";
import { professions } from "@bonliva-crm/common";
import { encodeProfAoeSpec } from "@bonliva-crm/common/ConsultantSearch";
import { ExpertiseFragment } from "@graphql";
// import { CloudUpload } from "@material-ui/icons";

type Props = {
  disabled?: boolean;
  error?: string;
  filterProfessions?: (profession: string) => boolean;
  filterAoe?: (aoe: ExpertiseFragment) => boolean;
  filterSpecializations?: (spec: string) => boolean;
  fullWidth?: boolean;
  onChange: (values: string[]) => void;
  showSearchInput?: boolean;
  skipChipDeleteIcon?: boolean;
  useChip?: boolean;
  value: string[];
};

export function NestedExpertiseSelect(props: Props) {
  const {
    filterProfessions = (x) => x,
    filterAoe = (x) => x,
    filterSpecializations = (x) => x
  } = props;

  const singleAreasOfExpertise = store().cache.areasOfExp.filter((x) => {
    const siblingsAndOwn = store().cache.areasOfExp.filter(
      (y) => x.Profession === y.Profession
    );
    return siblingsAndOwn.length === 1;
  });

  const items = store().cache.professions.filter(filterProfessions);

  const options = items
    .map((x) => ({
      label: professions.getProfessionDisplayName(x),
      value: encodeProfAoeSpec(x),
      parent: "",
      hasChildren: true
      // icon: <CloudUpload />
    }))
    .concat(
      store()
        .cache.areasOfExp.filter((aoe) => !singleAreasOfExpertise.includes(aoe))
        .filter(filterAoe)
        .map((x) => ({
          label: `${x.Name}`,
          value: encodeProfAoeSpec(x.Profession, x.Name),
          parent: encodeProfAoeSpec(x.Profession),
          hasChildren: true
          // icon: <CloudUpload />
        }))
    )
    .concat(
      store().cache.areasOfExp.flatMap((aoe) =>
        aoe.Specializations.filter(filterSpecializations)
          .map((spec) => {
            const isSingleAoe = singleAreasOfExpertise.includes(aoe);

            const parent = isSingleAoe
              ? encodeProfAoeSpec(aoe.Profession)
              : encodeProfAoeSpec(aoe.Profession, aoe.Name);

            return {
              label: spec,
              value: encodeProfAoeSpec(aoe.Profession, aoe.Name, spec),
              parent,
              hasChildren: false

              // icon: <CloudUpload />
            };
          })
          .sortBy((x) => x.label)
      )
    );

  return useObserver(() => (
    <Select
      error={!!props.error}
      showSearchInput={props.showSearchInput}
      clearable={true}
      disabled={props.disabled}
      fullWidth={props.fullWidth ?? true}
      groupBy="parent"
      inputRenderer={(inputProps) => null}
      label={locale.AreasOfExpertise}
      multi
      skipChipDeleteIcon={props.skipChipDeleteIcon ?? true}
      multiType={props.useChip ? "chips" : null}
      nested
      onChange={props.onChange}
      onFocusCustom={(instance) => instance.openMenu()}
      options={options}
      optionType="checkbox"
      value={props.value}
    />
  ));
}

NestedExpertiseSelect.defaultProps = {
  useChip: true
} as Partial<Props>;
